export default __webpack_public_path__ + "static/media/safe7-intro-ur.e5ee054a.png";